import config from "@/config";
import http from "@/utils/request";

export default {
	give: {
		list: {
			url: `${config.API_URL}/admin/market_activity/list`,
			name: "获取满赠活动列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/market_activity/store`,
			name: "新增编辑满赠活动",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/market_activity/detail`,
			name: "获取满赠活动详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/market_activity/del`,
			name: "删除满赠活动",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	reduction: {
		list: {
			url: `${config.API_URL}/admin/market_reduction/list`,
			name: "获取满减活动列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/market_reduction/store`,
			name: "新增编辑满减活动",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/market_reduction/detail`,
			name: "获取满减活动详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/market_reduction/del`,
			name: "删除满减活动",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	coupon: {
		list: {
			url: `${config.API_URL}/admin/coupon/index`,
			name: "获取优惠券列表",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/coupon/store`,
			name: "新增编辑优惠券",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/coupon/show`,
			name: "获取优惠券详情",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		updateStatus: {
			url: `${config.API_URL}/admin/coupon/enable`,
			name: "启用禁用优惠券",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		mylist: {
			url: `${config.API_URL}/admin/coupon/mylist`,
			name: "获取优惠券用户领取记录",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	homepage: {
		list: {
			url: `${config.API_URL}/admin/homepage/list`,
			name: "获取首页礼包列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/homepage/store`,
			name: "新增编辑首页礼包",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/homepage/detail`,
			name: "获取首页礼包详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/homepage/del`,
			name: "删除首页礼包",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	wealth: {
		list: {
			url: `${config.API_URL}/admin/wealth/list`,
			name: "获取扫码测评列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/wealth/store`,
			name: "新增编辑扫码测评",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/wealth/detail`,
			name: "获取扫码测评详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/wealth/del`,
			name: "删除扫码测评",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		relevant: {
			url: `${config.API_URL}/admin/wealth/relevant`,
			name: "获取属相列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	collecting: {
		list: {
			url: `${config.API_URL}/admin/card_collecting/list`,
			name: "获取集卡活动列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/card_collecting/store`,
			name: "新增编辑集卡活动",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/card_collecting/detail`,
			name: "获取集卡活动详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/card_collecting/del`,
			name: "删除集卡活动",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	praise: {
		list: {
			url: `${config.API_URL}/admin/like_activity/list`,
			name: "获取集赞活动列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/like_activity/store`,
			name: "新增编辑集赞活动",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/like_activity/detail`,
			name: "获取集赞活动详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/like_activity/del`,
			name: "删除集赞活动",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
	},
	luckynumber: {
		list: {
			url: `${config.API_URL}/admin/user_lucky/getLuckyList`,
			name: "获取吉祥号列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		info: {
			url: `${config.API_URL}/admin/user_lucky/getLuckyInfo`,
			name: "获取单个吉祥号信息",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		add: {
			url: `${config.API_URL}/admin/user_lucky/addLucky`,
			name: "新增吉祥号",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/user_lucky/updateLucky`,
			name: "修改吉祥号",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/user_lucky/deleteLucky`,
			name: "删除吉祥号",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		auditList: {
			url: `${config.API_URL}/admin/user_lucky/getLuckyAuditList`,
			name: "获取吉祥号审核列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		auditInfo: {
			url: `${config.API_URL}/admin/user_lucky/getLuckyAuditInfo`,
			name: "获取单个吉祥号审核信息",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		updateAudit: {
			url: `${config.API_URL}/admin/user_lucky/auditLucky`,
			name: "审核吉祥号",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		deleteAudit: {
			url: `${config.API_URL}/admin/user_lucky/deleteLuckyAudit`,
			name: "删除吉祥号审核数据",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		calculateMobile: {
			url: `${config.API_URL}/admin/user_lucky/calculateMobile`,
			name: "查询手机号吉凶",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
};
